module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var dead = Util.clone(value); 
    ; __append("\n\n")
    ;  if (dead.removed) { 
    ; __append("\n\n<b>УДАЛЁН</b>\n\n")
    ;  } else { 
    ; __append("\n\n")
    ;  if (Util.isDefined(dead.type) && dead.type != Glonass.DeadType.Unknown) { 
    ; __append("\n<div>\n	<b>")
    ; __append(escapeFn( Glonass.DeadType.title(dead.type) ))
    ; __append("</b>\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (dead.person) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Person", {value: dead.person, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  if (dead.address) { 
    ; __append("\n<div>\n	<b>Адрес:</b>\n	")
    ; __append( card.render("Address", {value: dead.address, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}